export enum TENANT_STATUS {
  ACTIVE = 'ACTIVE',
  DEACTIVATE = 'DEACTIVATE',
  DELETED = 'DELETED',
  EXPIRED = 'EXPIRED',
  // update if payment not done
  PAYMENT_DEACTIVATE = 'P_DEACTIVATE',
  PENDING = 'PENDING',
  TRIAL_ENDED = 'TRIAL_ENDED',
  TRIAL_EXTENDED = 'TRIAL_EXTENDED',
  SUSPENDED = 'SUSPENDED',
}

export enum TENANT_METHOD {
  PAYABLE = 'P',
  FREE_TRIAL = 'FT',
  FREE_FOREVER = 'FF',
}

export enum TENANT_TYPE {
  INDIVIDUAL = 'INDIVIDUAL',
  GROUP = 'GROUP',
  DEFAULT = 'DEFAULT',
}

// BMS
export enum USER_LIMIT_TYPE {
  INCREASES = 'I',
  DECREASES = 'D',
}
export enum REGISTRATION_METHODS {
  SELF = 'SELF',
  MANUAL = 'MANUAL',
}
